export const LogicalReflectorSymbol = Symbol('LogicalReflector')
export const LogicalReflectorStateSymbol = Symbol('LogicalReflectorState')

export const name = 'pages' as const
